import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  UserActions,
  profileActions,
  instructorActions,
  centersActions,
  SubscriptionActions,
  paymentActions,
} from "../../../redux/actions";
import BecomeCertifiedPractitioner from "../../../container/views/becomeCertifiedPractitioner/BecomeCertifiedPractitioner";
import BecomeVerified from "../../../container/views/becomeverifiedUser/BecomeVerified";
import {
  getCurrentUserRole,
  getUserPayload,
  getUserStatus,
  isShowInstructorButton,
  isShowPractitionerButton,
  isShowFreelanceButton,
  getLocalStorageItem,
  unloadWidget,
} from "../../../system";
import {
  CenterStatusEnum,
  freelanceInstructorConstants,
  freelanceStatusEnum,
  modalConstants,
  roles,
  StorageKeys,
  subscriptionTypeConstants,
  UserVerificationApprovalStatus,
} from "../../../constants";
import { Button } from "react-bootstrap";
import { translationConstants } from "../../../constants";
import BecomeFreelanceInstructor from "../Modals/BecomeFreelanceInstructor";
import BecomeCenterInstructor from "./BecomeCenterInstructor";
import { ToastifyService } from "../../../services";
import CenterPaymentForm from "../../../container/views/CenterPayment/CenterPaymentForm";
import { allSharedComponents } from "../..";
import BecomeFreelanceInstructorPayment from "../Modals/BecomeFreelanceInstructorPayment";

const { GeneralLogo, BaseForm, CustomModal } = allSharedComponents;

const BecomeInstructorPractitioner = () => {
  const [userDocumentStatus, setUserDocumentStatus] = useState();
  const modalOpen = useSelector((state) => state.UserReducer.openModal);
  const DocumentStatus =
    useSelector((state) => {
      return state.LoginReducer.userDocumentStatus;
    }) ?? getUserStatus();

  const { t } = useTranslation();

  const [vat, setVat] = useState();
  const [pricing, setPrice] = useState();
  const [priceBreakdown, setPriceBreakdown] = useState(null);
  const [isInstructorPending, setIsInstructorPending] = useState();
  const [isShowFreelanceInstructor, setShowFreelanceInstructor] =
    useState(false);
  const [isShowFreelancePaymentModal, setShowFreelancePaymentModal] =
    useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const dispatch = useDispatch();
  const role = getCurrentUserRole();
  const userData = getUserPayload();

  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );
  const centerProfileData = useSelector(
    (state) => state.centersReducer.centerProfileData
  );
  const userAssociatedCenterId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.centerId
  );
  const isCenterRepaymentModal = useSelector(
    (state) => state.centersReducer.isCenterRePaymentModal
  );
  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );
  const freelanceData = useSelector(
    (state) => state.InstructorReducer.freelanceInstructorSportsDetail
  );

  useEffect(() => {
    if (role === roles.FreelanceInstructor) {
      dispatch(
        SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
      );
      dispatch(
        instructorActions.getFreelancerSportsDetail(userData?.instructorId)
      );
    }
  }, []);

  useEffect(() => {
    if (role === roles.FreelanceInstructor) {
      const vatPercentage = subscriptionPrices?.find(
        (x) => x.subcriptionType === subscriptionTypeConstants.VAT
      )?.price;
      if (vatPercentage) setVat(vatPercentage);
      const filteredPrices = subscriptionPrices?.filter((x) => {
        const isMatchingSportId = freelanceData?.sportIds?.includes(
          x.subcriptionType
        );
        const isFreelancer = x.userType === roles?.FreelanceInstructor;
        return isMatchingSportId && isFreelancer;
      });
      const breakdownSports = filteredPrices?.map((x) => {
        const newFormat = { sport: x.subcriptionType, price: x.price };
        return newFormat;
      });
      const subTotal = filteredPrices.reduce(
        (acc, item) => acc + item.price,
        0
      );
      const vatPrice = (vatPercentage / 100) * subTotal;
      const totalPrice = vatPrice + subTotal;
      const pricingBreakdown = {
        sports: breakdownSports,
        subTotal: subTotal,
        vatPrice: vatPrice,
        vatPercentage: vatPercentage,
        totalPrice: totalPrice,
      };
      setPriceBreakdown(pricingBreakdown);
      setPrice(subTotal);
    }
  }, [subscriptionPrices, freelanceData]);

  const onSetShow = () => {
    dispatch(UserActions.OpenModal(false));
    dispatch(UserActions.setQualificationFormState([]));
  };

  useEffect(() => {
    setUserDocumentStatus(DocumentStatus);
    /*eslint-disable-next-line */
  }, [DocumentStatus]);

  useEffect(() => {
    if (
      `${getLocalStorageItem(StorageKeys.instructorStatus)}` ===
      `${UserVerificationApprovalStatus.Pending}`
    )
      setIsInstructorPending(true);
    else setIsInstructorPending(false);
    /*eslint-disable-next-line */
  }, [getLocalStorageItem(StorageKeys.instructorStatus)]);

  const openFreelanceInstructorModal = () => {
    if (userAssociatedCenterId == null) {
      setShowFreelanceInstructor(true);
    } else {
      ToastifyService.showSuccess(
        t(
          translationConstants.PLEASE_GET_REMOVED_FROM_CENTER_TO_BECOME_FREELANCE_INSTRUCTOR
        )
      );
    }
  };

  const isInstructorActive = () => {
    const activeRole = getLocalStorageItem(StorageKeys.activeRole);
    return role === roles.Instructor && activeRole === roles.Instructor;
  };

  const centerPaymentModalHandler = (data) => {
    unloadWidget();
    dispatch(paymentActions.paymentCheckoutNull());
    dispatch(centersActions.toggleCenterRepaymentModal(data));
  };

  return (
    <>
      {userData?.user?.role === roles.Center &&
        (centerProfileData?.centerStatus === CenterStatusEnum.PaymentRejected ||
          centerProfileData?.centerStatus === CenterStatusEnum.Restricted) && (
          <>
            <div className="d-none d-md-block">
              {/* Show only on large screens */}
              <div className="topBanner p-r-50 p-l-50 d-flex justify-content-between top-banner-height">
                <div className="d-flex align-items-center my-2 col-12 col-md-8 col-lg-9 col-xl-7 w-100">
                  <div className="d-flex align-items-center">
                    <p>
                      {`${t(
                        translationConstants.YOUR_ANNUAL_PAYMENT_FOR_CENTER_SUBSCRIPTION_WAS_DECLINED
                      )} ${t(translationConstants.CLICK_HERE_TO_RENEW)}`}
                    </p>
                  </div>
                  <div className="d-flex">
                    <Button
                      className="approve-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => {
                        dispatch(
                          centersActions.toggleCenterRepaymentModal(true)
                        );
                        dispatch(paymentActions.paymentCheckoutNull());
                      }}
                    >
                      {t(translationConstants.PAY)}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-md-none">
              {/* Show only on medium and small screens */}
              <div className="topBanner p-r-50 p-l-50 justify-content-end">
                <div className="my-2 col-12">
                  <div className="d-flex">
                    <p>
                      {`${t(
                        translationConstants.YOUR_ANNUAL_PAYMENT_FOR_CENTER_SUBSCRIPTION_WAS_DECLINED
                      )} ${t(translationConstants.CLICK_HERE_TO_RENEW)}`}
                    </p>
                  </div>
                  <div className="d-flex">
                    <Button
                      className="approve-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => {
                        dispatch(
                          centersActions.toggleCenterRepaymentModal(true)
                        );
                        dispatch(paymentActions.paymentCheckoutNull());
                      }}
                    >
                      {t(translationConstants.PAY)}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <CustomModal
              size="sm"
              show={isCenterRepaymentModal}
              scrollable={true}
              setShow={centerPaymentModalHandler}
              closeBtnClasses={"login-modal-close-btn"}
            >
              <BaseForm>
                <GeneralLogo />
                <CenterPaymentForm setShow={centerPaymentModalHandler} />
              </BaseForm>
            </CustomModal>
          </>
        )}
      {isShowFreelanceInstructor && (
        <BecomeFreelanceInstructor
          isShow={isShowFreelanceInstructor}
          setShow={setShowFreelanceInstructor}
        />
      )}

      {isShowFreelancePaymentModal && (
        <CustomModal
          scrollable
          show={isShowFreelancePaymentModal}
          setShow={setShowFreelancePaymentModal}
          size="sm"
          closeBtnClasses={"login-modal-close-btn"}
        >
          <BaseForm>
            <GeneralLogo />
            <BecomeFreelanceInstructorPayment
              title={t(translationConstants.FREELANCE_INSTRUCTOR_PAYMENT)}
              price={{ current: pricing }}
              vat={vat}
              sportIds={freelanceData?.sportIds}
              spotId={freelanceData?.spotId}
              pricingBreakdown={priceBreakdown}
            />
          </BaseForm>
        </CustomModal>
      )}

      {role === roles.VerifiedUser &&
        (isShowInstructorButton(role, userData) ||
          isShowPractitionerButton(role, userData)) &&
        !isInstructorPending && (
          <div className="certifiedDiv p-r-50 p-l-50 ">
            {isShowInstructorButton(role, userData) && (
              <Button
                onClick={() => {
                  dispatch(UserActions.OpenModal(true));
                  setSelectedComponent(modalConstants.BecomeInstructor);
                }}
              >
                {t(translationConstants.BecomeInstructor)}
              </Button>
            )}
            {isShowPractitionerButton(role, userData) ? (
              <Button
                onClick={() => {
                  dispatch(UserActions.OpenModal(true));
                  setSelectedComponent(modalConstants.BecomePractitioner);
                }}
              >
                {t(translationConstants.BecomePractitioner)}
              </Button>
            ) : (
              ""
            )}
          </div>
        )}

      {role === roles.GeneralUser &&
        `${userDocumentStatus}` !==
          `${UserVerificationApprovalStatus.Pending}` && (
          <div className="certifiedDiv p-r-50 p-l-50">
            <Button
              onClick={() => {
                dispatch(UserActions.OpenModal(true));
                dispatch(profileActions.getProfileData(systemUserId));
                setSelectedComponent(modalConstants.BecomeVerified);
              }}
            >
              {t(translationConstants.becomeVerifiedUser)}
            </Button>
          </div>
        )}

      {isInstructorActive() &&
      isShowFreelanceButton(role) &&
      !userData?.instructorCenterId &&
      !getLocalStorageItem(StorageKeys.instructorInvitedCenterName) ? (
        <div className="certifiedDiv p-r-50 p-l-50">
          <Button
            onClick={() => {
              openFreelanceInstructorModal();
            }}
          >
            {t(translationConstants.BECOME_FREELANCE_INSTRUCTOR)}
          </Button>
        </div>
      ) : (
        <BecomeCenterInstructor
          isFreelanceInstructor={role === roles.FreelanceInstructor}
          openFreelanceInstructorModal={openFreelanceInstructorModal}
        />
      )}

      {userData?.user?.role === roles.FreelanceInstructor &&
        (userData?.freelanceStatus === freelanceStatusEnum.PaymentRejected ||
          userData?.freelanceStatus === freelanceStatusEnum.Restricted) && (
          <>
            <div className="d-none d-md-block">
              {/* Show only on large screens */}
              <div className="topBanner p-r-50 p-l-50 d-flex justify-content-between top-banner-height">
                <div className="d-flex align-items-center my-2 col-12 col-md-8 col-lg-9 col-xl-7 w-100">
                  <div className="d-flex align-items-center">
                    <p>
                      {`${t(
                        translationConstants.YOUR_ANNUAL_PAYMENT_FOR_FREELANCE_SUBSCRIPTION_WAS_DECLINED
                      )} ${t(translationConstants.CLICK_HERE_TO_RENEW)}`}
                    </p>
                  </div>
                  <div className="d-flex">
                    <Button
                      className="approve-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => {
                        setShowFreelancePaymentModal(true);
                      }}
                    >
                      {t(translationConstants.PAY)}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-md-none">
              {/* Show only on medium and small screens */}
              <div className="topBanner p-r-50 p-l-50 justify-content-end">
                <div className="my-2 col-12">
                  <div className="d-flex">
                    <p>
                      {`${t(
                        translationConstants.YOUR_ANNUAL_PAYMENT_FOR_FREELANCE_SUBSCRIPTION_WAS_DECLINED
                      )} ${t(translationConstants.CLICK_HERE_TO_RENEW)}`}
                    </p>
                  </div>
                  <div className="d-flex">
                    <Button
                      className="approve-button mx-1 my-20 h-30"
                      type="button"
                      onClick={() => {
                        setShowFreelancePaymentModal(true);
                      }}
                    >
                      {t(translationConstants.PAY)}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

      {modalOpen && (
        <CustomModal
          scrollable
          show={modalOpen}
          setShow={onSetShow}
          size={
            selectedComponent === modalConstants.BecomeVerified ? "md" : "lg"
          }
        >
          {selectedComponent === modalConstants.BecomeInstructor && (
            <BecomeCertifiedPractitioner
              onSetShow={onSetShow}
              isInstructor={true}
            />
          )}
          {selectedComponent === modalConstants.BecomePractitioner && (
            <BecomeCertifiedPractitioner onSetShow={onSetShow} />
          )}
          {selectedComponent === modalConstants.BecomeVerified && (
            <BecomeVerified />
          )}
        </CustomModal>
      )}
    </>
  );
};

export default BecomeInstructorPractitioner;
